import { render, staticRenderFns } from "./PayPlus.vue?vue&type=template&id=6c00ed94&scoped=true"
import script from "./PayPlus.vue?vue&type=script&lang=js"
export * from "./PayPlus.vue?vue&type=script&lang=js"
import style0 from "./PayPlus.vue?vue&type=style&index=0&id=6c00ed94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c00ed94",
  null
  
)

export default component.exports